import { Component, Host, h, Prop, Element, Event, type EventEmitter } from '@stencil/core'

@Component({
  tag: 'cobalt-input-text',
  styleUrl: 'cobalt-input-text.css'
})
export class CobaltInputText {
  /**
   * The label that accompany the input field.
   */
  @Prop({ mutable: true }) label!: string
  /**
   * The value added inside the input. It can be used to add default value.
   */
  @Prop({ mutable: true }) value: string
  /**
   * Description is available on `outside` and `aside` format and will append below the label.
   */
  @Prop({ mutable: true }) description?: string
  /**
   * Placeholder inside the select.
   */
  @Prop({ mutable: true }) placeholder?: string
  /**
   * Mention displayed to indicate if the field is mandatory or optional. If none is selected `custom-requirement` slot is available.
   */
  @Prop({ mutable: true }) requirement?: 'mandatory' | 'optional' | 'none' = 'mandatory'
  /**
   * Position the label in different place.
   */
  @Prop({ mutable: true }) format?: 'inside' | 'outside' | 'aside' | 'hidden' = 'inside'
  /**
   * A boolean indicating the disable state of the input field. The `aria-disabled` attribute relies on this property.
   */
  @Prop({ mutable: true }) disabled?: boolean = false
  /**
   * Display an error message under the field and set the field in error state.
   */
  @Prop({ mutable: true }) errorMessage?: string = null

  /**
   * Emitted when the value has changed.
   */
  @Event() cobaltInputTextValueChange: EventEmitter
  /**
   * Emitted when typing inside the input.
   */
  @Event() cobaltInputTextTyping: EventEmitter

  @Element() element: HTMLElement

  handleOnChange = (event): void => {
    this.cobaltInputTextValueChange.emit(event.detail)
  }

  handleOnInput = (event): void => {
    this.cobaltInputTextTyping.emit(event.detail)
  }

  render(): any {
    return (
      <Host>
        <core-input-text
          label={this.label}
          value={this.value}
          description={this.description}
          placeholder={this.placeholder}
          requirement={this.requirement}
          format={this.format}
          disabled={this.disabled}
          errorMessage={this.errorMessage}
          onCoreInputTextValueChange={e => {
            this.handleOnChange(e)
          }}
          onCoreInputTextTyping={e => {
            this.handleOnInput(e)
          }}
        >
          <slot slot="before" name="before" />
          <slot slot="after" name="after" />
          {this.requirement === 'none' && <slot slot="custom-requirement" name="custom-requirement" />}
        </core-input-text>
      </Host>
    )
  }
}
